<template>
	<div>
		<el-form>
			<el-form-item label=""></el-form-item>
		</el-form>
		<el-table :data="tableData" :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
			:cell-style="{'text-align':'center'}">
			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column prop="coupon" label="券/券包"></el-table-column>
			<el-table-column prop="couponId" label="券/券包ID"></el-table-column>
			<el-table-column prop="url" label="跳转链接"></el-table-column>
			<el-table-column prop="imgSmall" label="小图"></el-table-column>
			<el-table-column prop="order" label="排序"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="deit(scope.row.id)">编辑</el-button>
					<el-button type="text" v-if="scope.row.businessType==1" @click="del(scope.row.id)"><span
							style="color: red;">删除</span></el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="text-align: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
				layout="total, sizes, prev, pager, next, jumper" :total="1">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [{
					id: 1,
					name: '测试',
					coupon: '券',
					couponId: '410',
					url: 'https://www.baidu.com',
					imgSmall: '',
					order: '1',
				}],
				query: {
					page: 1,
					size: 10
				}
			}
		},
		methods: {
			deit(id) {
				this.$router.push({
					path: 'market01',
					id: id
				})
			}
		}
	}
</script>

<style>
</style>